import { apiV2, errorHandler } from './index';
import {
  API_ERROR,
  FETCH_REQUESTS
} from '../constants/ActionTypes';

export function fetchRequests(page, page_size) {
  return function (dispatch) {
    apiV2.get(`/requests`, {
      params: {
        page,
        page_size,
      }
    })
      .then(response => {
        dispatch({
          type: FETCH_REQUESTS,
          payload: { ...response.data, per_page: page_size }
        });
      })
      .catch(error => {
        errorHandler(dispatch, error.response, API_ERROR);
      });
  };
}
